import {withRouter, Link} from 'react-router-dom'
import {observer} from 'mobx-react'
import Hammer from 'react-hammerjs'
import UI from '../stores/UI'
import CONTENT from '../stores/Content'

class Wrapper extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.updatePage()
    // window.scrollTo(0, 0)
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.updatePage()
      // window.scrollTo(0, 0)
    }
  }

  updatePage() {

    const path = this.props.location.pathname;
    UI.updateCurrentPath(path);
  }

  handleSwipe = e => {

    if (e.direction === 2) {
      if (UI.page < 3)
        UI.nextPage(UI.page + 1);
    } else if (e.direction === 4) {
      if (UI.page > 0)
        UI.nextPage(UI.page - 1);
    }
  }

  render() {

    return UI.isTouch ? (
      <Hammer className="wrap" onSwipe={this.handleSwipe} direction={"DIRECTION_HORIZONTAL"}>
        <div className="wrap">
          {this.props.children}
        </div>
      </Hammer>
    ) : (
      <div className="wrap">
        {this.props.children}
      </div>
    )
  }
}

export default withRouter(observer(Wrapper))



// WEBPACK FOOTER //
// ./app/javascript/packs/components/Wrapper.js